module.exports = __webpack_public_path__ + "img/a11.170ff05d.jpg";